// extracted by mini-css-extract-plugin
module.exports = {"container":"nolayersnotification_container__27chB","icon":"nolayersnotification_icon__II_m4","button":"nolayersnotification_button__19GVY"};